import CreateAdmin from './component'

export default CreateAdmin
